export const validateInputChange = (type, value) => {
    if (type === 'email') {
      const emailPattern = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
      return emailPattern.test(value) ? '' : 'آدرس ایمیل نامعتبر است';
    }
    if (type === 'number') {
      return isNaN(value) ? 'پورت نامعتبر است' : '';
    }
    return '';
  };
  
  export const isFormDataValid = (formData) => {
    return formData.some((item) => item.value.trim() === '');
  };
  
  export const hasInputErrors = (formData) => {
    return formData.some((item) => item.typeError && item.typeError !== '');
  };
  